import React, { Component } from 'react';
import Chart from 'react-apexcharts';
import { userStatus, envConfig, store } from '../../../_helpers';
import { Loader } from '../../../_components';
import { history } from '../../../_helpers';
import moment from 'moment';
import dayjs from 'dayjs';

export default class MomentumsChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      endpoint: this.props.endpoint,
      domain: this.props.parentDomain,
      raw_data: [],
      raw_labels: [],
      loaded: false,
      period: this.props.period,
      start: this.props.period.start,
      end: this.props.period.end,
      shouldShowChart: false,
      cardSize: 0,

      chartOptions: {},
      chartSeries: []
    }

    this.card = React.createRef();

    this.handleChartSwitch = this.handleChartSwitch.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  async componentDidMount() {
    this.listAnalyticsData(this.state.domain);
  }

  async componentWillReceiveProps(nextProps) {
    if ( nextProps.period.start === this.state.start && nextProps.period.end === this.state.end ) return;

    await this.setState({
      loaded: false,
      start: nextProps.period.start,
      end: nextProps.period.end,
      domain: this.state.domain,
      chartOptions: {},
      chartSeries: []
    }, () => this.listAnalyticsData(this.state.domain, this.state.start, this.state.end));
  }

  handleResize = () => {
    if ( !this.card.current ) return;
    this.setState({cardSize: this.card.current.offsetWidth - 115});
  }

  async listAnalyticsData(domain, start, end) {
    const user = userStatus();
    const { endpoint } = this.state;

    if ( !domain ) domain = this.state.domain;
    if ( !start ) start = this.state.start;
    if ( !end ) end = this.state.end;

    const url = `${envConfig.ANALYTICS_API_URL}/analytics/${domain}${endpoint}?start=${start.format('YYYY-MM-DD')}&end=${end.format('YYYY-MM-DD')}`;
    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${user.bearer_token}` }
    }

    const request = await fetch(url, options);

    if ( request.status !== 200 ) {
      this.setState({loaded: true});
      return Promise.reject(await request.json());
    }

    let response = await request.json();
    if ( response.data.length === 0 ) return;

    let arr = {}
    const data = response.data.map(data => {
      if ( !arr[data.momentum_title] ) {
        arr[data.momentum_title] = [];
        
        return arr[data.momentum_title].push({
          enviados: data.notifications_sent,
          visualizacoes: data.notifications_viewed,
          cliques: data.notifications_clicked,
          momentum: data.momentum_title,
          uuid: data.momentum_uuid,
          ctr: data.notifications_ctr,
          convertion: data.not_convertion,
          profit: data.not_convertion_profit ? data.not_convertion_profit : 0,
          cartAccess: data.not_cart_access,
          cartAccessPercent: data.not_cart_access_percent
        });
      }

      arr[data.momentum_title][0].enviados += data.notifications_sent;
      arr[data.momentum_title][0].visualizacoes += data.notifications_viewed;
      arr[data.momentum_title][0].cliques += data.notifications_clicked;
      arr[data.momentum_title][0].ctr = data.notifications_ctr;
      arr[data.momentum_title][0].cartAccess = data.not_cart_access;
      arr[data.momentum_title][0].cartAccessPercent = data.not_cart_access_percent;
      arr[data.momentum_title][0].convertion = data.not_convertion;
      arr[data.momentum_title][0].profit = data.not_convertion_profit ? data.not_convertion_profit : 0;
    });

    this.setState({loaded: true, raw_labels: Object.keys(arr), raw_data: arr});
  }

  async handleChartSwitch(e) {
    let user = userStatus();
    let uuid = e.target.getAttribute('data-momentum');

    if ( uuid === "return" ) return this.setState({shouldShowChart: false});

    this.setState({loaded: false, chartOptions: {}, chartSeries: []});

    const url = `${envConfig.ANALYTICS_API_URL}/analytics/momentum/${uuid}/count/dailyPeopleImpacted?start=${this.state.start.format('YYYY-MM-DD')}&end=${this.state.end.format('YYYY-MM-DD')}`;
    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${user.bearer_token}` }
    }

    const request = await fetch(url, options);

    if ( request.status !== 200 ) {
      this.setState({loaded: true});
      return Promise.reject(await request.json());
    }

    let response = await request.json();
    if ( response.data.length === 0 ) return;

    let dates = [];
    let sent = [];
    let viewed = [];
    let clicked = [];

    await response.data.map((data) => {
      let date = moment(data.date).format('DD/MM/YY');
      
      dates.push(date);
      sent.push(data.notifications_sent);
      viewed.push(data.notifications_viewed);
      clicked.push(data.notifications_clicked);
    });

    let chartOptions = {
      chart: { id: `momentum-${uuid}` },
      xaxis: { categories: dates }
    }
    let chartSeries = [
      {
        name: "Enviados",
        data: sent
      },
      {
        name: "Visualizados",
        data: viewed
      },
      {
        name: "Clicados",
        data: clicked
      }
    ]

    if ( !this.card.current ) {
      return this.setState({chartOptions, chartSeries, loaded: true, shouldShowChart: true});
    }
    this.setState({chartOptions, chartSeries, loaded: true, shouldShowChart: true, cardSize: this.card.current.offsetWidth - 115});
  }

  render() {
    const { raw_data } = this.state;

    return (
      <div key={this.props.title} className={`col-xs-12 col-sm-12 col-md-${this.props.colsize} col-lg-${this.props.colsize}`}>
        <div className="card" ref={this.card} style={this.state.shouldShowChart ? {justifyContent: 'center', alignItems: 'center'} : {}}>
          <p className="title title-outside">{this.props.title}</p>

          {
            !this.state.shouldShowChart ?
              this.state.loaded ?
                this.state.raw_data && this.state.raw_labels ?
                  <div className="table-responsive table-responsive-height">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Momentum</th>
                          <th title="Enviados"><i className="linearicons-paper-plane"></i></th>
                          <th title="Visualizados"><i className="linearicons-eye"></i></th>
                          <th title="Clicados"><i className="linearicons-mouse-left"></i></th>
                          <th title="CTR"><i className="linearicons-percent"></i></th>
                          <th title="Chegaram ao carrinho"><i className="linearicons-cart"></i></th>
                          {/* <th title="% Chegaram ao carrinho"><i className="linearicons-cart"></i></th> */}
                          <th title="Convertidos"><i className="linearicons-check"></i></th>
                          <th title="Total de vendas convertidas"><i className="linearicons-cash-dollar"></i></th>
                          {
                            this.state.end.diff(this.state.start, 'day') > 1 ?
                              <th title="Gráfico"><i className="linearicons-graph"></i></th>
                            : null
                          }
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.state.raw_labels.length > 0 ?
                            this.state.raw_labels.map(label => {
                              return <tr>
                                <td>{raw_data[label][0].momentum}</td>
                                <td>{raw_data[label][0].enviados}</td>
                                <td>{raw_data[label][0].visualizacoes}</td>
                                <td>{raw_data[label][0].cliques}</td>
                                <td>{raw_data[label][0].ctr}</td>
                                <td>{raw_data[label][0].cartAccess} ({raw_data[label][0].cartAccessPercent})</td>
                                {/* <td>{raw_data[label][0].cartAccessPercent}</td> */}
                                <td>{raw_data[label][0].convertion}</td>
                                <td>{raw_data[label][0].profit.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                {
                                  this.state.end.diff(this.state.start, 'day') > 1 ?
                                    <td><button className="btn btn-blue btn-icon btn-xs" data-momentum={raw_data[label][0].uuid} onClick={this.handleChartSwitch}>Visualizar</button></td>
                                  : null
                                }
                              </tr>
                            })
                          : null
                        }
                      </tbody>
                    </table>
                  </div>
                : null
              : <Loader className="is-blue" />
            : this.state.loaded ? <>
              <button onClick={this.handleChartSwitch} style={{marginLeft: "45px", marginRight: 0}} data-momentum="return" className="btn btn-blue btn-xs btn-icon"><i className="linearicons-arrow-left"></i></button>
              <Chart
                options={this.state.chartOptions}
                series={this.state.chartSeries}
                type="area"
                width={this.state.cardSize}
              />
            </> : <Loader className="is-blue" />

          }
        </div>
      </div>
    )
  }
}